import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { useMedia } from "./useMedia";
export const MediaFullscreen = ({ media }) => {
    const { embedUrl } = useMedia(media);
    if (!embedUrl)
        return null;
    return (_jsx(Box, { as: "iframe", src: embedUrl, width: "100%", maxHeight: "100%", allowFullScreen: true, unsafe_style: {
            aspectRatio: "4/3",
        } }));
};
